// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getInventoryRequest: ['data'],
  getInventorySuccess: ['data'],
  getInventoryFailure: ['err'],

  getInventoryCustomRequest: ['data'],
  getInventoryCustomSuccess: ['data'],
  getInventoryCustomFailure: ['err'],

  createInventoryRequest: ['data'],
  createInventorySuccess: ['data'],
  createInventoryFailure: ['err'],

  updateInventoryRequest: ['data'],
  updateInventorySuccess: ['data'],
  updateInventoryFailure: ['err'],

  updateInventoryImageRequest: ['data'],
  updateInventoryImageSuccess: ['data'],
  updateInventoryImageFailure: ['err'],

  deleteInventoryRequest: ['data'],
  deleteInventorySuccess: ['data'],
  deleteInventoryFailure: ['err']

})

export const InventoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  custom: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

export const successCustom = (state: Object, { data }: Object) =>
state.merge({
  fetching: false,
  custom: data,
  err: null
})

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_INVENTORY_SUCCESS]: success,
  [Types.GET_INVENTORY_REQUEST]: request,
  [Types.GET_INVENTORY_FAILURE]: failure,

  [Types.GET_INVENTORY_CUSTOM_SUCCESS]: successCustom,
  [Types.GET_INVENTORY_CUSTOM_REQUEST]: request,
  [Types.GET_INVENTORY_CUSTOM_FAILURE]: failure,

  [Types.CREATE_INVENTORY_SUCCESS]: success,
  [Types.CREATE_INVENTORY_REQUEST]: request,
  [Types.CREATE_INVENTORY_FAILURE]: failure,

  [Types.UPDATE_INVENTORY_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_INVENTORY_REQUEST]: manipulateRequest,
  [Types.UPDATE_INVENTORY_FAILURE]: manipulateFailure,

  [Types.UPDATE_INVENTORY_IMAGE_SUCCESS]: success,
  [Types.UPDATE_INVENTORY_IMAGE_REQUEST]: request,
  [Types.UPDATE_INVENTORY_IMAGE_FAILURE]: failure,

  [Types.DELETE_INVENTORY_SUCCESS]: manipulateSuccess,
  [Types.DELETE_INVENTORY_REQUEST]: manipulateRequest,
  [Types.DELETE_INVENTORY_FAILURE]: manipulateFailure

})



// WEBPACK FOOTER //
// ./src/Redux/InventoryRedux.js